<template>
    <div
        class="card-order"
        @click="onclickCard"
    >
        <div style="padding: 12px 40px 0px">
            <b-taglist>
                <b-tag type="is-info">#{{ id }}</b-tag>
                <b-tag type="is-dark">{{ status }}</b-tag>
                <b-tag type="is-danger">
                    <div>START: {{ startTime }}</div>
                </b-tag>
                <b-tag type="is-danger">
                    <div>END: {{ localUpdateAt }}</div>
                </b-tag>
                <b-tag
                    v-if="distance"
                    type="is-link"
                >
                    <div>DISTANCE: {{ distance }}</div>
                </b-tag>
                <b-tag
                    v-if="rating"
                    type="is-warning"
                >
                    <div>
                        <svg
                            style="width: 13px; height: 13px"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
                        </svg>
                        {{ calRating }}
                    </div>
                </b-tag>
                <b-tag type="is-success">RIDER: {{ driverName }}</b-tag>
                <b-tag
                    v-if="lalamoveTag.riderType === 'LLM'"
                    type="is-warning"
                    class="text-align: center;"
                >
                    LALAMOVE: {{lalamoveTag.lalamoveOrderID}}
                    <img
                        style="object-fit: contain; height: 20px; vertical-align: middle;"
                        :src="require('@/assets/lalamove.png')"
                        alt="The lalamove Logo"
                    />
                </b-tag>
            </b-taglist>
        </div>
        <div
            class="columns is-mobile"
            style="padding: 12px 40px 0px"
        >
            <div class="column is-3">
                <span class="heading">Origin</span>
                <p class="text-box">{{ origin }}</p>
            </div>
            <div class="column is-9">
                <span class="heading">Destination</span>
                <p :class="`${description ? '' : 'text-box'}`">{{ destination }}</p>
            </div>
        </div>
        <b-collapse
            :open="description"
            :style="`padding: 0 40px`"
            position="is-bottom"
            aria-id="contentIdForA11y1"
        >
            <div class="columns is-mobile">
                <div class="column is-3">
                    <span class="heading">Date</span>
                    <p class>{{ date }}</p>
                </div>
                <div class="column is-2">
                    <span class="heading">Time</span>
                    <p class>{{ time }}</p>
                </div>
                <div class="column is-5">
                    <span class="heading">name</span>
                    <p class>{{ name }}</p>
                </div>
                <div class="column is-2">
                    <span class="heading">price</span>
                    <p class>{{ price }}</p>
                </div>
            </div>
            <div
                v-if="rating"
                class="columns is-mobile"
            >
                <div class="column is-4">
                    <span class="heading">rating employee</span>
                    <p class>{{ rating.ratingEmployee }}</p>
                </div>
                <div class="column is-4">
                    <span class="heading">rating address</span>
                    <p class>{{ rating.ratingAddress }}</p>
                </div>
                <div class="column is-4">
                    <span class="heading">rating order</span>
                    <p class>{{ rating.ratingOrder }}</p>
                </div>
            </div>
        </b-collapse>
        <section v-if="lalamoveTag.riderType !== 'LLM'">
            <div style="padding: 0px 40px 12px">
                <b-button
                    class="download-btn"
                    style="margin-right:12px"
                    type="is-info is-light"
                    size="is-small"
                    icon-pack="fas"
                    icon-left="cloud-download-alt"
                    @click="onClickDownloadIMG('pickupImg')"
                >รูปถ่ายสินค้าก่อนส่ง</b-button>
                <b-button
                    class="download-btn"
                    style="margin-right:12px"
                    type="is-success is-light"
                    size="is-small"
                    icon-pack="fas"
                    icon-left="cloud-download-alt"
                    @click="onClickDownloadIMG('deliveredImg')"
                >สินค้าส่งสำเร็จ</b-button>
                <b-button
                    class="download-btn"
                    type="is-warning is-light"
                    size="is-small"
                    icon-pack="fas"
                    icon-left="cloud-download-alt"
                    @click="onClickDownloadIMG('successImg')"
                >ลายเซ็น</b-button>
            </div>
        </section>
    </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  props: [
    "id",
    "time",
    "date",
    "name",
    "distance",
    "rating",
    "price",
    "origin",
    "destination",
    "status",
    "driverName",
    "updatedAt",
    "lalamoveTag",
  ],
  data() {
    return {
      description: false,
      startTime: null,
      localUpdateAt: null,
    };
  },
  computed: {
    calRating() {
      return (this.rating.ratingOrder + this.rating.ratingEmployee + this.rating.ratingAddress) / 3;
    },
  },
  async mounted() {
    this.startTime = await this.$store.dispatch("orders/getLogOrderByID", {
      status: "PICKUP",
      id: this.id,
    });
    this.localUpdateAt = await this.$store.dispatch("orders/getLogOrderByID", {
      status: "SUCCESS",
      id: this.id,
    });
    this.startTime = dayjs(this.startTime).format("HH:mm");
    this.localUpdateAt = dayjs(this.localUpdateAt).format("HH:mm");
  },
  methods: {
    onClickDownloadIMG(statusImg) {
      this.$store.dispatch("imageDownload/getDownloadURL", { id: this.id, statusImg: statusImg });
    },
    onclickCard() {
      const position = {
        origin: this.origin,
        destination: this.destination,
        id: this.id,
        active: this.description,
      };
      this.description = !this.description;
      this.$emit("onclick", position);
    },
    onclickFindVilla() {
      this.$emit("onfindVilla", this.id);
    },
  },
};
</script>

<style scoped>
.card-order {
  border: 1px solid white;
  cursor: pointer;
  color: white;
  /* border-radius: 10px; */
  /* margin: 0.5rem 0.5rem; */
  border-bottom: 1px solid #e8e8e8;
}
.card-order {
  background-color: white;
  color: #2c2a74;
}
.card-order:hover {
  background-color: #f0f0f0;
  color: #2c2a74;
}
.download-btn {
  opacity: 0.7;
}
.download-btn:hover {
  opacity: 1;
}

.text-title {
  font-size: 13px;
}
.text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.columns:not(:last-child) {
  margin-bottom: 0;
}
p {
  /* font-size: 14px; */
}
</style>
